import { useState } from 'react';
import './App.css';
import Cart from './components/Cart/Cart';
import Header from './components/Layout/Header';
import Meals from './Meals/Meals';
import CartProvider from './store/CartProvider';

function App() {
 const [cartIsShown, setCartIsShown] = useState(false);

 const showCartHandler = () => {
  setCartIsShown(true);
 }

 const hideCartHandler = () => {
  setCartIsShown(false);
 }

  return (
    <div>
      <CartProvider>
        {cartIsShown && <Cart onClose={hideCartHandler}/>}
        <Header onShowCart={showCartHandler}/>
        <main>
          <Meals />
        </main>
      </CartProvider>
    </div>
  );
}

export default App;
